import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5","key":"svg-0"}],["path",{"d":"M12 12l8 -4.5","key":"svg-1"}],["path",{"d":"M12 12l0 9","key":"svg-2"}],["path",{"d":"M12 12l-8 -4.5","key":"svg-3"}]]

const IconBox = createReactComponent('outline', 'box', 'Box', __iconNode);

export default IconBox;